var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "v-tooltip",
        { attrs: { bottom: "" } },
        [
          _c(
            "v-btn",
            {
              attrs: {
                slot: "activator",
                icon: "",
                color: "#00857D",
                outline: ""
              },
              on: {
                click: function() {
                  this$1.dialog = this$1.dialog ? false : true
                }
              },
              slot: "activator"
            },
            [_c("v-icon", [_vm._v("today")])],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v("Ver detalle")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", width: "900" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { color: "#00857D", dark: "" } },
                [
                  _c("v-icon", [_vm._v("today")]),
                  _vm._v(" "),
                  _c("b", [_vm._v("VER DETALLE DEL DÍA")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "py-3 px-0" },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass:
                                "text-xs-center font-weight-bold blue--text",
                              staticStyle: { "font-size": "1.5em" },
                              attrs: { elevation: "0" }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.persona.ap_paterno +
                                      " " +
                                      _vm.persona.ap_materno +
                                      " " +
                                      _vm.persona.nombres
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "text-xs-center titulo-fecha",
                              attrs: { dark: "" }
                            },
                            [
                              _c(
                                "v-tooltip",
                                { attrs: { bottom: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        slot: "activator",
                                        outlined: "",
                                        icon: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.actualizaFecha(-1)
                                        }
                                      },
                                      slot: "activator"
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { large: "", color: "blue" } },
                                        [_vm._v("chevron_left")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Anterior")])
                                ],
                                1
                              ),
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm
                                      .$moment(_vm.fecha_actual)
                                      .format("DD/MM/YYYY")
                                  ) +
                                  "\n              "
                              ),
                              _c(
                                "v-tooltip",
                                { attrs: { bottom: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        slot: "activator",
                                        outlined: "",
                                        icon: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.actualizaFecha(1)
                                        }
                                      },
                                      slot: "activator"
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { large: "", color: "blue" } },
                                        [_vm._v("chevron_right")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Siguiente")])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.lista_detalle_dia.length > 0
                            ? _c(
                                "div",
                                _vm._l(_vm.lista_detalle_dia, function(
                                  detalle
                                ) {
                                  return _c(
                                    "v-card",
                                    {
                                      key: detalle.hora_marcada,
                                      staticClass: "px-1"
                                    },
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs4: "", md2: "" } },
                                            [
                                              _c("CuadroDetalle", {
                                                attrs: {
                                                  detalle: detalle.horario,
                                                  titulo: "HORARIO",
                                                  color: "AliceBlue",
                                                  ruta_icono:
                                                    "static/images/reloj.png"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { attrs: { xs4: "", md2: "" } },
                                            [
                                              _c("CuadroDetalle", {
                                                attrs: {
                                                  detalle: detalle.tolerancia,
                                                  titulo: "TOLERANCIA",
                                                  color: "AliceBlue",
                                                  ruta_icono:
                                                    "static/images/reloj.png"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { attrs: { xs4: "", md2: "" } },
                                            [
                                              _c("CuadroDetalle", {
                                                attrs: {
                                                  detalle: detalle.hora_marcada,
                                                  titulo: "MARCADO",
                                                  color: "AliceBlue",
                                                  ruta_icono:
                                                    "static/images/reloj.png"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { attrs: { xs4: "", md2: "" } },
                                            [
                                              _c("CuadroDetalle", {
                                                attrs: {
                                                  detalle: detalle.atraso,
                                                  titulo: "ATRASO",
                                                  color: "#80CBC4",
                                                  ruta_icono:
                                                    "static/images/reloj.png"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "text-xs-center",
                                              attrs: { md4: "" }
                                            },
                                            [
                                              _c("b", [
                                                _vm._v("OBSERVACIÓN: ")
                                              ]),
                                              _vm._v(
                                                _vm._s(
                                                  detalle.bandera_marcado
                                                    ? detalle.bandera_marcado
                                                    : "-"
                                                ) + "\n                    "
                                              ),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("b", [_vm._v("DETALLE: ")]),
                                              _vm._v(
                                                _vm._s(
                                                  detalle.descripcion_caso
                                                ) + "\n                  "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-divider")
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            : _c("div", { staticClass: "text-xs-center" }, [
                                _c("h4", [_vm._v("NO EXISTE DATOS")])
                              ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3759c8a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3759c8a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/asistencia/components/VerDetalleDia.vue
// module id = null
// module chunks = 